import { Compass, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

type ProjectHomeEmptyStateProps = {
  onCreateProject: () => void;
};

function BadgeLine({ children }: { children: string }) {
  return (
    <div className="inline-flex rounded-full bg-secondary px-4 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-secondary-foreground">
      {children}
    </div>
  );
}

export function ProjectHomeEmptyState({
  onCreateProject,
}: ProjectHomeEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <Card className="project-shell-hero overflow-hidden border-white/75">
      <CardContent className="grid gap-8 px-6 py-10 sm:grid-cols-[1.1fr_0.9fr] sm:px-10">
        <div className="space-y-5">
          <BadgeLine>{t("projects.portfolio.emptyBadge")}</BadgeLine>
          <div className="space-y-3">
            <h1 className="font-display text-4xl text-foreground sm:text-5xl">
              {t("projects.portfolio.emptyTitle")}
            </h1>
            <p className="max-w-2xl text-base leading-7 text-muted-foreground">
              {t("projects.portfolio.emptyBody")}
            </p>
          </div>
          <Button className="w-fit" onClick={onCreateProject} size="lg" type="button">
            <Plus className="h-4 w-4" />
            {t("projects.portfolio.emptyAction")}
          </Button>
        </div>
        <div className="project-shell-panel p-6">
          <div className="cover-fallback flex h-full min-h-64 flex-col justify-between rounded-[24px] p-6 text-primary-foreground shadow-inner">
            <Compass className="h-8 w-8" />
            <div className="space-y-2">
              <p className="text-sm uppercase tracking-[0.24em] text-primary-foreground/85">
                {t("projects.portfolio.emptyScopeTitle")}
              </p>
              <ul className="space-y-2 text-sm leading-6 text-primary-foreground/95">
                <li>{t("projects.portfolio.emptyScopeCreate")}</li>
                <li>{t("projects.portfolio.emptyScopeLifecycle")}</li>
                <li>{t("projects.portfolio.emptyScopeDashboard")}</li>
                <li>{t("projects.portfolio.emptyScopeUpgrade")}</li>
              </ul>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
